const chatCodes = [{
  code: "<?3!A6@<OP|B{",
  action: "chat-reset"
}]
 
export default chatCodes;